/** Shared time units and localized duration formatting. */

export const SECONDS_PER_DAY = 86400;
export const MS_PER_DAY = SECONDS_PER_DAY * 1000;
export const SECONDS_PER_HOUR = 3600;
export const MS_PER_HOUR = SECONDS_PER_HOUR * 1000;
export const SECONDS_PER_MINUTE = 60;
export const MS_PER_MINUTE = SECONDS_PER_MINUTE * 1000;
export const HOURS_PER_YEAR = 24 * 365;

export function getTimeRemaining(startTime: number, endTime: number) {
  const diff = Math.max(0, endTime - startTime);
  const s = 1000;
  const m = s * 60;
  const h = m * 60;
  const d = h * 24;
  const days = Math.floor(diff / d);
  const hours = Math.floor((diff % d) / h);
  const minutes = Math.floor((diff % h) / m);
  const seconds = Math.floor((diff % m) / s);
  return { days, hours, minutes, seconds };
}

export function decomposeDuration(seconds: number): {
  days: number;
  hours: number;
  minutes: number;
} {
  const days = Math.floor(seconds / SECONDS_PER_DAY);
  const hours = Math.floor((seconds % SECONDS_PER_DAY) / SECONDS_PER_HOUR);
  const minutes = Math.floor((seconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
  return { days, hours, minutes };
}

// Formats seconds into human-readable duration: "3 days", "1 day 4 hours 48 minutes"
export const formatLockdownDurationLabel = (
  seconds: number,
  t: (key: string) => string,
): string => {
  const { days, hours, minutes } = decomposeDuration(seconds);
  const parts: string[] = [];
  if (days > 0) parts.push(`${days} ${t(days === 1 ? "day" : "days")}`);
  if (hours > 0) parts.push(`${hours} ${t(hours === 1 ? "hour" : "hours")}`);
  if (minutes > 0) parts.push(`${minutes} ${t(minutes === 1 ? "minute" : "minutes")}`);
  return parts.join(" ") || `0 ${t("minutes")}`;
};
